// frontend/src/components/admin/modals/GrantTicketsModal.jsx
import React, { useState } from 'react';
import axios from '../../../config/axios';

const GrantTicketsModal = ({ user, onClose, onSuccess }) => {
    const [amount, setAmount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            // Cambiar la URL al endpoint específico para administradores
            // Este endpoint debe estar implementado en tu backend para registrar
            // la transacción como ADMIN_ADJUSTMENT
            const response = await axios.post('/admin/users/grant-tickets', {
                userId: user.id,
                amount: parseInt(amount),
                // Añadir un campo opcional para indicar que viene del panel de admin
                source: 'admin_panel'
            });

            if (response.data.success) {
                onSuccess(response.data.user);
                onClose();
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Error al otorgar tickets');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-md w-full">
                <h2 className="text-xl font-bold text-primary mb-4">
                    Otorgar Tickets a {user.username}
                </h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Cantidad de Tickets
                        </label>
                        <input
                            type="number"
                            min="1"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary focus:border-primary"
                            required
                        />
                    </div>

                    {error && (
                        <p className="text-red-500 text-sm">{error}</p>
                    )}

                    <div className="flex justify-end space-x-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-light disabled:opacity-50"
                        >
                            {loading ? 'Otorgando...' : 'Otorgar Tickets'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default GrantTicketsModal;